import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NotificationServerSettingsService } from 'mbs-ui-shared@services/notification-server-settings.service';
import {Alert, AlertService, MbsPopupType, MbsSize, ModalService} from 'mbs-ui-kit';
import {UnableEmailsModalComponent} from "@components/unable-emails-modal/unable-emails-modal.component";
import { AppPersistentStateService } from "mbs-ui-shared@services";
import {AbilityService} from "ability";
import {PermissionsEnum} from "mbs-ui-shared";

@UntilDestroy()
@Component({
  selector: 'mbs-unable-deliver-emails-alert',
  templateUrl: './unable-deliver-emails-alert.component.html'
})
export class UnableDeliverEmailsAlertComponent implements AfterViewInit {
  @ViewChild('alertTemplate', { static: true }) alertTemplate: TemplateRef<any>;

  protected readonly MbsSize = MbsSize;

  constructor(
    private notificationService: NotificationServerSettingsService,
    private alertService: AlertService,
    private modalService: ModalService,
    private appStorage: AppPersistentStateService,
    private abilityService: AbilityService
  ) {}

  ngAfterViewInit(): void {
    this.abilityService.can('read', PermissionsEnum.Notification) && this.notificationService.getBounceListLength().pipe(untilDestroyed(this)).subscribe(count=>{
      if(count && this.appStorage.data.showAlertAboutBounceList){
        queueMicrotask(() =>
          this.alertService.alert(new Alert({ content: this.alertTemplate, ignoreRouteChanges: true,  id: 'unable-deliver-emails', type: MbsPopupType.danger })).subscribe(()=>{
            this.appStorage.data.showAlertAboutBounceList = false
          })
        );
      }
    })
  }

  public showDetails(){
    this.modalService.openCustom(UnableEmailsModalComponent, {
      size: MbsSize.xl
    })
  }
}
